import request from '@/utils/request';

let merchantApi = {
    // 商户交易量查询
    getQuery(data, err) {
        return request._get('/shop/posConsumptionRecords/posConsumptionRecords/selectCountList', data, err);
    },
  // 商户交易量查询
  getQueryTotal(data, err) {
    return request._get('/shop/posConsumptionRecords/posConsumptionRecords/selectTotal', data, err);
  }

}

export default merchantApi;




// WEBPACK FOOTER //
// ./src/api/merchant/query.js